<ng-template #content let-modal>
    <div class="toast-content">
        <button *ngIf="!autoClose" type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss()"
            style="position: absolute;right: 12px;top: 12px;outline: none !important;z-index: 999;"></button>
        <div class="modal-body">
            <div class="row">
                <div class="col-2 p-0 d-flex my-auto {{ isSuccess ? 'success' : 'error'}}">
                    <i class="m-auto fa fa-{{ isSuccess ? 'check' : 'close'}}"></i>
                </div>
                <div class="col p-0 ps-2 pe-3 d-flex">
                    <div class="my-auto" [innerHtml]="message"></div>
                </div>
            </div>
        </div>
        <div class="modal-footer" *ngIf="!autoClose">
            <button type="button" class="btn btn-ok" (click)="modal.close()">Close</button>
        </div>
    </div>
</ng-template>